import { render, staticRenderFns } from "./Works.vue?vue&type=template&id=2ae00c88&scoped=true"
import script from "./Works.vue?vue&type=script&lang=js"
export * from "./Works.vue?vue&type=script&lang=js"
import style0 from "./Works.vue?vue&type=style&index=0&id=2ae00c88&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae00c88",
  null
  
)

export default component.exports